export default __webpack_public_path__ + "static/media/no-opportunities-weget-icon.bd4455c1.svg";